import React, { useState } from "react";
import { Loader } from "../../../../../Components/NewUI/Common/Loader";
import ToastMsg from "../../../../../helper/ToastMsg";
import { handleTUTermsRedirect } from "../../../../../utils/helper";
import ElectricImage from "../../../../../Images/ElectricityImage.png";
import PaperLess from "../../../../../Images/paperlessImage.png";
import WelcomeLoanTag from "../../../../../Images/welomeBadge.jpg";
import HomeCross from "../../../../../Images/homeCross.png";
import ElectricityImage from "../../../../../Images/Electricity.png";
import clock from "../../../../../Images/CapaClock.png"
import { default as personalIcon } from "../../../../../Images/personal-loan.png";

const After90DaysLoanReject = ({ onCheckNow }) => {
  const [agreed, setAgreed] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleCheckNow = () => {
    if (!agreed || loading) return;

    const token = localStorage.getItem("gpay_token");
    setLoading(true);
    onCheckNow(token)
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        setLoading(false);
        ToastMsg(err?.response?.data?.error || "Something went wrong", "error");
      });
  };

  if (loading) return <Loader />;

  return (
    <div className="a90-loanBox">
      <div className="superTag">
        <img height={29} width={126} src={WelcomeLoanTag} />
      </div>

      <div className="a90-inner">
        <div>
        <div className="a90-Capa flex gap-3 align-items-start mb-1">
            <img height={44} width={44} src={clock} />
            <div>
                <p className="m-0 heading-1-a90">You're Ready to <span>Apply Again!</span></p>
                <p className="m-0 heading-2-a90">Your 60-day wait is over.</p>
            </div>
        </div>
        <div className="a90-topRow">
          <div className="a90-leftCol">
            <div className="loanPart3 flex align-items-end">
              <img src={personalIcon} className="imageLoan" />
              <div className="a90-amountBlock">
                <span className="superSpanSmall text-start">Up to</span>
                <span className="a90-amountText">
                  <span className="rupeEsign">₹</span>2,00,000
                </span>
              </div>
            </div>
          </div>

          <div className="typeSuper">
            <p className="superP-90days">
              <span>No Collateral</span>
              <img height={10} width={10} src={HomeCross} />
            </p>
            <div className="flex gap-6px">
            <p className="superP-90days">
              <span>Instant</span>
              <img height={10} width={6} src={ElectricityImage} />
            </p>
            <p className="superP-90days">
              <span>Paperless</span>
              <img height={10} width={10} src={PaperLess} />
            </p>
            </div>
          </div>
        </div>
        </div>
        <hr className="horizontal-bar" />

        <div className="a90-consentRow">
          <input
            type="checkbox"
            className="a90-checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <span className="a90-consentText">
            I agree to the{" "}
            <a
              className="a90-consentLink"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleTUTermsRedirect(); }}
              href="#"
            >
              Terms and Conditions
            </a>{" "}
            of TU CIBIL and hereby provide explicit consent to share my Credit
            Information with our NBFC partners.
          </span>
        </div>
        <div className="w-100">
        <div
          onClick={handleCheckNow}
          className={`a90-checkNowBtn${agreed && !loading ? "" : " a90-checkNowBtn--disabled"}`}
        >
          <span className="superGet">Apply Now</span>
          <img height={25} width={16} src={ElectricImage} />
        </div>
        <p className="text-center belowCheckbox">Safe &nbsp;·&nbsp; Secure &nbsp;·&nbsp; Trusted by 10L+ Users</p>
        </div>
      </div>
    </div>
  );
};

export default After90DaysLoanReject;